/*
 * <countdown-timer data-end="2026-08-31T23:59:00+05:00">
 *
 * data-end is written by the section in the shop's own timezone offset, so the
 * deadline is the same wall-clock moment for every shopper regardless of where
 * they are. Nothing renders server-side beyond placeholders; the first tick
 * runs immediately on connect so there is no visible flash of "--".
 */
class CountdownTimer extends HTMLElement {
  connectedCallback() {
    this.deadline = Date.parse(this.dataset.end);
    if (Number.isNaN(this.deadline)) return;

    this.unitsEl = this.querySelector('[data-countdown-units]');
    this.finishedEl = this.querySelector('[data-countdown-finished]');
    this.fields = {
      days: this.querySelector('[data-countdown-days]'),
      hours: this.querySelector('[data-countdown-hours]'),
      minutes: this.querySelector('[data-countdown-minutes]'),
      seconds: this.querySelector('[data-countdown-seconds]'),
    };

    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  tick() {
    const remaining = this.deadline - Date.now();
    if (remaining <= 0) {
      this.finish();
      return;
    }

    const total = Math.floor(remaining / 1000);
    this.write('days', Math.floor(total / 86400));
    this.write('hours', Math.floor((total % 86400) / 3600));
    this.write('minutes', Math.floor((total % 3600) / 60));
    this.write('seconds', total % 60);
  }

  write(key, value) {
    const el = this.fields[key];
    if (el) el.textContent = String(value).padStart(2, '0');
  }

  finish() {
    clearInterval(this.interval);

    if (this.dataset.hideWhenFinished === 'true') {
      const section = this.closest('.top-banner');
      (section || this).hidden = true;
      return;
    }

    if (this.unitsEl) this.unitsEl.hidden = true;
    if (this.finishedEl) this.finishedEl.hidden = false;
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
